var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',{staticClass:"mb-0",staticStyle:{"color":"#a1a1a1"}},[_vm._v("N/A")]),_c('p',{staticStyle:{"color":"#a1a1a1"}},[_vm._v("No data available for "+_vm._s(_vm.sectionTitle)+" yet.")])])}
var staticRenderFns = []

export { render, staticRenderFns }